module.exports = __webpack_public_path__ + "img/account_outer_white.3239ea77.svg";